import React from 'react';

const InboxIcon = () => {
  return (
    <svg
      width="22"
      height="18"
      viewBox="0 0 22 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1 9H4.88197C5.56717 9 6.19357 9.38713 6.5 10C6.80643 10.6129 7.43283 11 8.11803 11H13.882C14.5672 11 15.1936 10.6129 15.5 10C15.8064 9.38713 16.4328 9 17.118 9H21M1 9V5.8C1 4.11984 1 3.27976 1.32698 2.63803C1.6146 2.07354 2.07354 1.6146 2.63803 1.32698C3.27976 1 4.11984 1 5.8 1H16.2C17.8802 1 18.7202 1 19.362 1.32698C19.9265 1.6146 20.3854 2.07354 20.673 2.63803C21 3.27976 21 4.11984 21 5.8V9M1 9V12.2C1 13.8802 1 14.7202 1.32698 15.362C1.6146 15.9265 2.07354 16.3854 2.63803 16.673C3.27976 17 4.11984 17 5.8 17H16.2C17.8802 17 18.7202 17 19.362 16.673C19.9265 16.3854 20.3854 15.9265 20.673 15.362C21 14.7202 21 13.8802 21 12.2V9"
        stroke="#fff"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
export const NewInboxIcon = () => {
  return (
    <svg
      width="41"
      height="40"
      viewBox="0 0 41 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10.3999 20H14.2819C14.9671 20 15.5935 20.3871 15.8999 21C16.2063 21.6129 16.8327 22 17.5179 22H23.2819C23.9671 22 24.5935 21.6129 24.8999 21C25.2063 20.3871 25.8327 20 26.5179 20H30.3999M10.3999 20V16.8C10.3999 15.1198 10.3999 14.2798 10.7269 13.638C11.0145 13.0735 11.4734 12.6146 12.0379 12.327C12.6797 12 13.5197 12 15.1999 12H25.5999C27.2801 12 28.1201 12 28.7619 12.327C29.3264 12.6146 29.7853 13.0735 30.0729 13.638C30.3999 14.2798 30.3999 15.1198 30.3999 16.8V20M10.3999 20V23.2C10.3999 24.8802 10.3999 25.7202 10.7269 26.362C11.0145 26.9265 11.4734 27.3854 12.0379 27.673C12.6797 28 13.5197 28 15.1999 28H25.5999C27.2801 28 28.1201 28 28.7619 27.673C29.3264 27.3854 29.7853 26.9265 30.0729 26.362C30.3999 25.7202 30.3999 24.8802 30.3999 23.2V20"
        stroke="#22CCEE"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
export const NewSelectedInboxIcon = () => {
  return (
    <svg
      width="41"
      height="40"
      viewBox="0 0 41 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect x="0.399902" width="40" height="40" rx="20" fill="#91bee7" />
      <path
        d="M10.3999 20H14.2819C14.9671 20 15.5935 20.3871 15.8999 21C16.2063 21.6129 16.8327 22 17.5179 22H23.2819C23.9671 22 24.5935 21.6129 24.8999 21C25.2063 20.3871 25.8327 20 26.5179 20H30.3999M10.3999 20V16.8C10.3999 15.1198 10.3999 14.2798 10.7269 13.638C11.0145 13.0735 11.4734 12.6146 12.0379 12.327C12.6797 12 13.5197 12 15.1999 12H25.5999C27.2801 12 28.1201 12 28.7619 12.327C29.3264 12.6146 29.7853 13.0735 30.0729 13.638C30.3999 14.2798 30.3999 15.1198 30.3999 16.8V20M10.3999 20V23.2C10.3999 24.8802 10.3999 25.7202 10.7269 26.362C11.0145 26.9265 11.4734 27.3854 12.0379 27.673C12.6797 28 13.5197 28 15.1999 28H25.5999C27.2801 28 28.1201 28 28.7619 27.673C29.3264 27.3854 29.7853 26.9265 30.0729 26.362C30.3999 25.7202 30.3999 24.8802 30.3999 23.2V20"
        stroke="white"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default InboxIcon;
